let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aTh4P")).then(() => parcelRequire('5FM0W'));